import * as React from "react";

const subscribe = () => () => {};

function shuffle<T>(items: readonly T[]): T[] {
  const next = [...items];
  // Fisher-Yates
  for (let i = next.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [next[i], next[j]] = [next[j], next[i]];
  }
  return next;
}

/**
 * `items` in a random order, picked once per mount. Hydration renders the given order
 * (the server snapshot) so the markup matches, then re-renders shuffled.
 */
export function useShuffled<T>(items: readonly T[]): readonly T[] {
  const [shuffled] = React.useState(() => shuffle(items));
  return React.useSyncExternalStore(
    subscribe,
    () => shuffled,
    () => items,
  );
}
